import React from 'react';

export const Eye = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 37"
    fill="none"
    {...props}
  >
    <path
      d="M14.625 18.4944C14.625 17.5993 14.9806 16.7408 15.6135 16.1079C16.2465 15.475 17.1049 15.1194 18 15.1194C18.8951 15.1194 19.7535 15.475 20.3865 16.1079C21.0194 16.7408 21.375 17.5993 21.375 18.4944C21.375 19.3895 21.0194 20.2479 20.3865 20.8809C19.7535 21.5138 18.8951 21.8694 18 21.8694C17.1049 21.8694 16.2465 21.5138 15.6135 20.8809C14.9806 20.2479 14.625 19.3895 14.625 18.4944Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 18.4944C3 20.9544 3.6375 21.7809 4.9125 23.4384C7.458 26.7444 11.727 30.4944 18 30.4944C24.273 30.4944 28.542 26.7444 31.0875 23.4384C32.3625 21.7824 33 20.9529 33 18.4944C33 16.0344 32.3625 15.2079 31.0875 13.5504C28.542 10.2444 24.273 6.49438 18 6.49438C11.727 6.49438 7.458 10.2444 4.9125 13.5504C3.6375 15.2094 3 16.0359 3 18.4944ZM18 12.8694C16.5082 12.8694 15.0774 13.462 14.0225 14.5169C12.9676 15.5718 12.375 17.0025 12.375 18.4944C12.375 19.9862 12.9676 21.417 14.0225 22.4719C15.0774 23.5268 16.5082 24.1194 18 24.1194C19.4918 24.1194 20.9226 23.5268 21.9775 22.4719C23.0324 21.417 23.625 19.9862 23.625 18.4944C23.625 17.0025 23.0324 15.5718 21.9775 14.5169C20.9226 13.462 19.4918 12.8694 18 12.8694Z"
      fill="currentColor"
    />
  </svg>
);
